import Vue from 'vue'

export default new Vue

// 跨组件通讯